import Input from 'features/common/components/Input'
import {useTypedTranslation} from 'i18n'

type FormInputFieldProps = {
    icon: string
    iconAlt: string
    error?: string
    inputProps: React.ComponentProps<typeof Input>
}

const FormInput = ({icon, iconAlt, error, inputProps}: FormInputFieldProps) => {
    const {t} = useTypedTranslation()
    return (
        <div className="justify-stretch flex flex-1 flex-col self-center">
            <div className="relative flex h-[3.75rem]">
                <img
                    className="absolute left-[1.125rem] top-1/2 w-[1.875rem] -translate-y-1/2"
                    src={icon}
                    alt={iconAlt}
                />
                <Input
                    className="w-full pl-[4.6875rem] text-xl"
                    {...inputProps}
                />
            </div>
            {error && (
                <div className="pl-4 text-sm text-red-700">{t(error)}</div>
            )}
        </div>
    )
}

export default FormInput
